import React from 'react';
import { Box, Stack } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';

import { ListingFiltersValues } from './types';
import { EventsListing } from './EventsListing';
import { ListingFilters } from './ListingFilters';
import { CalendarViewComponentProps } from '../../types';
import { getInitialFilters } from '../../constants';

export const Listing = ({ userProfileId }: Pick<CalendarViewComponentProps, 'userProfileId'>) => {
  const form = useForm<ListingFiltersValues>({ defaultValues: getInitialFilters() });

  return (
    <FormProvider {...form}>
      <Stack gap="0.5rem" sx={{ flex: 1, minHeight: 0 }}>
        <ListingFilters />

        <Box sx={{ flex: 1, minHeight: 0 }}>
          <EventsListing key={userProfileId ?? 'me'} userProfileId={userProfileId} />
        </Box>
      </Stack>
    </FormProvider>
  );
};
